import { render, staticRenderFns } from "./CampaignEditDetails.vue?vue&type=template&id=5c615b06&"
import script from "./CampaignEditDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports